import { render, staticRenderFns } from "./FirmwareVersionsTable.vue?vue&type=template&id=7241de9b&scoped=true"
import script from "./FirmwareVersionsTable.vue?vue&type=script&lang=ts"
export * from "./FirmwareVersionsTable.vue?vue&type=script&lang=ts"
import style0 from "./FirmwareVersionsTable.vue?vue&type=style&index=0&id=7241de9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7241de9b",
  null
  
)

export default component.exports